import type {Relation} from 'typeorm';
import {
  Column,
  Entity,
  JoinColumn,
  JoinTable,
  ManyToMany,
  ManyToOne,
  OneToMany,
  OneToOne,
  RelationId,
  TableInheritance
} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {Team} from "@/modules/team/entity";
import {MaxLength} from "class-validator";
import {Competition, DivisionPromotion, Matchday} from ".";

@Entity()
@TableInheritance({column: {type: "varchar", name: "type"}})
export class Division extends BaseEntity {
  @Column({type: 'varchar', length: '50'})
  @MaxLength(50)
  name: string;

  @OneToOne(() => Division, r => r.next)
  @JoinColumn()
  prev?: Division;

  @RelationId((m: Division) => m.prev)
  prevId?: number;

  @OneToOne(() => Division, r => r.prev)
  next?: Division;

  @RelationId((m: Division) => m.next)
  nextId?: number;

  @OneToMany(() => DivisionPromotion, promotion => promotion.division)
  promotions: DivisionPromotion[];

  @OneToMany(() => DivisionPromotion, promotion => promotion.target_division)
  targetedPromotions: DivisionPromotion[];

  @ManyToOne(() => Competition, competition => competition.divisions)
  competition: Competition;

  @RelationId((division: Division) => division.competition)
  competitionId: number;

  @ManyToMany(() => Team, team => team.divisions)
  @JoinTable()
  teams: Relation<Team[]>;

  @RelationId((m: Division) => m.teams)
  teamIds: number[];

  @OneToMany(() => Matchday, matchday => matchday.division)
  matchdays: Matchday[];

  @Column({type: 'boolean'})
  finished = false;

  get hasMatches() {
    return !!this.matchdays.find(matchday => matchday.matches.length > 0);
  }
}
